// extracted by mini-css-extract-plugin
export default {"headerBackground":"style_headerBackground__V5lPB","headerContent":"style_headerContent__c8zip","nav_ul":"style_nav_ul__fV3oV","onScroll":"style_onScroll__LtYFH"};